import { Respondent } from './respondent';
import {JsonObject, JsonProperty} from 'json2typescript';

@JsonObject('Synchro')
export class Synchro {
    @JsonProperty('device_id',Number)
    deviceId = 0;

    @JsonProperty('synchronized_time',String)
    time = '';

    @JsonProperty('device_name',String)
    deviceName = '';

    @JsonProperty('ip_address',String)
    ipAddress = '';

    @JsonProperty('respondents',[Respondent],true)
    respondents: Respondent[] = [];

    // TODO: check why is this variable used
    @JsonProperty('expanded',Boolean)
    expanded:boolean;

    @JsonProperty('total_number_of_respondents',Number)
    totalNumberOfRespondents = 0;
}
